import autoresponder from "../../api/autoresponder";
import { perPageCount } from "@/common/constants";
import { dummyRows, StatusIcon, convertCount } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
      search_val: "",
      date_from: "",
      date_to: "",
      senderId: "",
      status: "",
      sort_field: "modifiedDate",
      sort_order: "desc",
      add_sort: 0,
    },
    totalItems: 0,
    campaigns: [],
    total: 0,
    busyLoaderStatus: true,
    showFilter: false,
  };
};
// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }

    return state.items.map((item) => {
      var status = item.status;
      // if (item.stage === 'Expired') {
      //   status = 'Limit Reached'
      //   item.statusVal = 1
      // }
      var icon = StatusIcon(status);
      return {
        id: item.id,
        cname: { title: item.cname, text: item.subject },
        auto_status: { text: status, type: icon },
        scheduleDate: item.mDate,
        modifiedTime: item.autoDatetime,
        isAmp: [3, 4].includes(item.contenttype),
        openRate: {
          first: item.openRate + "%",
          second: convertCount(item.opens),
        },
        auto_actions: {
          Edit: status === "Published" || status === "Scheduled",
          "Test Mail": parseInt(item.type) !== 4,
          Activate:
            parseInt(item.statusVal) !== 0 ||
            status === "Expired" ||
            status === "Limit Reached",
          Deactivate:
            status === "Limit Reached" ||
            status === "Inactive" ||
            status === "Duplicate" ||
            status === "Expired" ||
            status === "Draft",
          Delete: status !== "Draft" && status !== "Duplicate",
        },
      };
    });
  },

  getCampaigns: (state) => {
    return state.campaigns.map((item) => {
      var rule = item.rule ? JSON.parse(item.rule) : {};
      var queuedTotal = item.queuedTotal;
      if (
        rule.ruleLimit &&
        parseInt(rule.ruleLimit) < parseInt(item.queuedTotal)
      ) {
        queuedTotal = rule.ruleLimit;
      }
      return {
        id: item.id,
        name: item.campName,
        idNum: item.campNum,
        count: parseInt(queuedTotal),
        scheduleDate: item.scheduleDate,
      };
    });
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.search_val !== params.search_val ||
      filter.date_from !== params.date_from ||
      filter.date_to !== params.date_to ||
      filter.senderId !== params.senderId ||
      filter.status !== params.status ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve) {
        autoresponder.fetchItems(params, (data) => {
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  deleteAutoresponder({ dispatch }, { id }) {
    return autoresponder.delete(id).then(function () {
      dispatch("refreshItems");
    });
  },

  duplicateAutoresponder({ dispatch }, { id }) {
    return autoresponder.duplicate(id).then(function () {
      dispatch("refreshItems");
    });
  },
  activateAutoresponder({ dispatch }, { id }) {
    return autoresponder.activate(id).then(function () {
      dispatch("refreshItems");
    });
  },
  deactivateAutoresponder({ dispatch }, { id }) {
    return autoresponder.deactivate(id).then(function () {
      dispatch("refreshItems");
    });
  },

  fetchAllCampaigns({ commit }, { id }) {
    commit("setCampaign", []);
    autoresponder.fetchAllCampaigns({ id }, (data) => {
      commit("setCampaign", data);
    });
  },

  resetState({ commit }) {
    commit("resetState");
  },

  publishAutoresponder(_, params) {
    return autoresponder.publishAutoresponder(params);
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setCampaign(state, campaigns) {
    state.campaigns = campaigns;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setShowFilter(state, status) {
    state.showFilter = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
